
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import CoverageHero from './components/CoverageHero';
import CaliforniaMap from './components/CaliforniaMap';
import CoverageStats from './components/CoverageStats';
import RegionCards from './components/RegionCards';
import DeploymentProcess from './components/DeploymentProcess';
import CoverageCTA from './components/CoverageCTA';

export default function CoverageAreasPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <main>
        <CoverageHero />
        <CoverageStats />
        <CaliforniaMap />
        <RegionCards />
        <DeploymentProcess />
        <CoverageCTA />
      </main>
      <Footer />
    </div>
  );
}
